import { defineAction } from '~/prix'
import patchNotesAction from './generalPatchNotes.action.json' with { type: 'json' }
import { z } from 'zod'

const patchNotesDefinition = defineAction({
  ...patchNotesAction,
  // group: 'Notas de Atualização',
  // title: 'Notas de Atualização',
  access: 'authenticated',
  input: z.object({
    filter: z.string().nullish(),
    type: z.enum(['publicSafety', 'publicHealth', 'prixGov']),
  }),
  output: z.object({
    items: z.record(
      z.array(
        z.object({
          patchVersion: z.string().nullish(),
          patchDate: z.string().nullish(),
          patchName: z.string().nullish(),
          newFeatures: z
            .array(
              z.object({
                featureName: z.string().nullish(),
                featureDescription: z.string().nullish(),
              }),
            )
            .nullish(),
          improvements: z
            .array(
              z.object({
                improvementName: z.string().nullish(),
                improvementDescription: z.string().nullish(),
              }),
            )
            .nullish(),
          bugFixes: z
            .array(
              z.object({
                bugDescription: z.string().nullish(),
              }),
            )
            .nullish(),
          removedFeatures: z
            .array(
              z.object({
                removedFeatureName: z.string().nullish(),
                removedFeatureDescription: z.string().nullish(),
              }),
            )
            .nullish(),
        }),
      ),
    ),
  }),
})

export default patchNotesDefinition
